import { lazyPage } from "@/router/lazyPage";

export const NotFound = lazyPage(() => import("@/pages/NotFound"), "NotFound");
